const comMain2 = () => {
  if (document.querySelector("section#jsComSecMain2") !== null) {



    const secMain = document.querySelector('#jsComSecMain2');
    const mainWrap = secMain.querySelector('.js-main-wrap');
    const copyBox = mainWrap.querySelector('.js-copy-box');


    setTimeout(() => {
      copyBox.classList.add('is-act')
    }, 400);



  }
}
export default comMain2;